import { render, staticRenderFns } from "./batch-edit-modal.vue?vue&type=template&id=05d7f708&scoped=true"
import script from "./batch-edit-modal.vue?vue&type=script&lang=js"
export * from "./batch-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7f708",
  null
  
)

export default component.exports